import { render, staticRenderFns } from "./ShippingGratesView.vue?vue&type=template&id=253c8670&"
import script from "./ShippingGratesView.vue?vue&type=script&lang=js&"
export * from "./ShippingGratesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports